<template>
    <div>
        <template v-for="name in service.loopForNames">
            <component
                :is="service.componentMap[name]"
                v-if="service.attrMap[name].vIf"
                :key="name"
                v-bind="service.attrMap[name].$props"
                v-on="service.attrMap[name].$listeners"
            />
        </template>
    </div>
</template>

<script>
export default {
    name: 'DialogAutoMountPoint',
    props: {
        service: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            s: this.service,
        };
    },
};
</script>
